Ext.define('SA.data.ReportView', {
    alias: 'view.report',
    extend: 'SA.data.View',

    mixins: {
        attributes: 'SA.data.mixin.ManyAttributes'
    },

    hasDataMap: true,

    addAttributeImpl(attribute) {
        this.mixins.attributes.addAttributeImpl.call(this, attribute);

        this.project.addAttribute(attribute);
    },

    clearDataMap() {
        Ext.destroy(this.dataMap);
        this.dataMap = null;
    },

    getDataMap() {
        return this.dataMap || (this.dataMap = this.createDataMap());
    },

    getExportQuery() {
        throw new Error('Not implemented');
    },

    getLatestCensusRelease() {
        if (!this.latestCensusRelease) {
            this.latestCensusRelease = this.project.getLatestCensusRelease();
        }

        return this.latestCensusRelease;
    },

    getQueryLocation() {
        return SA.data.LocationsCache.normalizeLocation(this.getLocation());
    },

    getQueryLocations() {
        return this.getLocations().map(SA.data.LocationsCache.normalizeLocation);
    },

    getReportData() {
        throw new Error('Not implemented');
    },

    getStrikeoutFilterDerivedAttribute(filter) {
        return {filter: ['with', filter, 'filter']};
    },

    isSavable() {
        return this.getLocations().length && this.getAttributes().length;
    },

    onCustomLocationUpdateImpl() {
        if (!this.hasDataMap) {
            return;
        }

        this.clearDataMap();
    },

    removeAttributeImpl(attribute) {
        this.mixins.attributes.removeAttributeImpl.call(this, attribute);

        if (!this.hasDataMap) {
            return;
        }

        this.getDataMap().removeAttribute(attribute);
    },

    removeLocationImpl(location) {
        this.mixins.locations.removeLocationImpl.call(this, location);

        if (!this.hasDataMap) {
            return;
        }

        this.getDataMap().removeLocation(SA.data.LocationsCache.normalizeLocation(location));
    }
});